import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryQuickEntry from "@/pages/home/components/CategoryQuickEntry";
import MovieSection from "@/pages/home/components/MovieSection";
import HotRanking from "@/pages/home/components/HotRanking";
import SiteIntro from "@/pages/home/components/SiteIntro";
import { movies } from "@/mocks/movies";
import { getByType } from "@/utils/movies";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

export default function Home() {
  useDocumentMeta(
    "爱看视频_免费在线观看影视剧和电影平台",
    "爱看视频提供丰富的影视剧和电影资源，涵盖最新电视剧、热门电影和综艺节目，满足用户在线观看和影视内容浏览需求。"
  );

  const tvLatest = getByType("tv").slice(0, 6);
  const movieHot = [...getByType("movie")].sort((a, b) => b.views - a.views).slice(0, 6);
  const varietyLatest = getByType("variety").slice(0, 6);
  const topRanking = [...movies].sort((a, b) => b.views - a.views).slice(0, 8);

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1">
        <HeroCarousel />
        <CategoryQuickEntry />

        <MovieSection
          title="电视剧最新更新"
          description="热门剧集持续跟进，追剧不再等待"
          movies={tvLatest}
          moreTo="/category/tv"
        />

        <MovieSection
          title="电影热映推荐"
          description="院线佳片与高分遗珠，一次看个够"
          movies={movieHot}
          moreTo="/category/movie"
        />

        <MovieSection
          title="综艺欢乐精选"
          description="真人秀、音乐竞演，周末的快乐源泉"
          movies={varietyLatest}
          moreTo="/category/variety"
        />

        <HotRanking movies={topRanking} />

        <SiteIntro />
      </main>
      <SiteFooter />
    </div>
  );
}